import {DateTime} from "luxon";
import type {XlsxRow} from "./types.ts";

export function throwIfInvalid(dt: DateTime): DateTime<true> {
    if (!dt.isValid) throw Error("Invalid DateTime: " + dt);
    return dt;
}

export function getAtDate(historic: XlsxRow[], date: DateTime) {
    return historic.find(p =>
        p.date.toISODate() === date.toISODate()
    );
}